<template>
	<div class="container">
		<h4 class="item">作业预警成员</h4>
		<Table size="small" 
			class="item"
			:columns="columns"
			:data="data"
		>
			<template slot-scope="{ row, index }" slot="operation">
				<Button type="text" @click="handleEdit(row)">编辑</Button>
				<Poptip v-model="row.removeConfirmVisible">
					<Button type="text">删除</Button>
					<div slot="title">确定删除该条目？</div>
					<div slot="content" class="align-center">
						<Button
							size="small"
							@click="row.removeConfirmVisible = false"
						>取消</Button>
						<Button
							type="error"
							size="small"
							@click="handleRemove(row)"
						>确定</Button>
					</div>
				</Poptip>
			</template>
		</Table>
		
		<Button
			type="dashed"
			size="large"
			long
			@click="handleAdd"
			disabled
		>
			<Icon type="md-add" />
			新增成员
		</Button>
	</div>
</template>

<script>
	export default {
		props: {
			warningMemberList: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {
				columns: [
					{
						title: "成员",
						key: "name"
					},
					{
						title: "工号",
						key: "employeeNumber"
					},
					{
						title: "所属部门",
						key: "department"
					},
					{
						title: "操作",
						slot: "operation"
					}
				],
				data: [
					/* {
						id: 1,
						name: "ADMIN",
						employeeNumber: "01234567",
						department: "HAIER UPLUS"
					} */
				]
			};
		},
		methods: {
			handleEdit(row) {
				console.log(row);
			},
			handleRemove(row) {
				console.log(row);
				row.removeConfirmVisible = false;
			},
			handleAdd() {
				
			}
		}
	};
</script>

<style scoped>
	.ivu-table {
		font-size: 14px;
	}
	
	.ivu-table-wrapper {
		overflow: visible;
	}
</style>
